import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ListResponse } from 'src/app/models/ListResponse';
import { OpenDataList } from 'src/app/models/OpenDataList';
import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ResourcesService } from 'src/app/services/resources.service';
import { environment } from 'src/environments/environment';
import { OpenDataCategoryList } from 'src/app/models/openDataCategoryList';

@Component({
  selector: 'app-open-data',
  templateUrl: './open-data.component.html',
  styleUrls: ['./open-data.component.css']
})
export class OpenDataComponent implements OnInit {

  reasearchList: OpenDataList[] = [];
  researchCategory:OpenDataList[] = [];
  reasearchListResponse : OpenDataList[] = [];
  data : OpenDataCategoryList [] = [];
  imptempPublicUrl = environment.imptempPublicUrl;
  imgPublicUrl = environment.imgPublicUrl;
  reportdownload = '';
  home = '';
  PageTitle = '';
  reportsearch: string = '';
  searchText: any = '';
  _lang = '';
  Category = '';
  all = '';
  more = '';
  downloadCount = '';
  PublishDate = '';
  tagsAll = true;
  hasCategory = false;
  tags: string[] = [];
  selectedTags: string[] = [];
  tagsStatus: boolean[] = [];
  tagsNumber: number[] = [];
  EtecFullName = 'هيئة تقويم التعليم والتدريب';
  destroy$: Subject<boolean> = new Subject<boolean>();
  categoryname = ''
  constructor(private actRoute: ActivatedRoute, private service: ApiService, private Title: Title, private apiResources: ResourcesService, private loading: LoadingService) {
    this.actRoute.params.subscribe(async params => {
      this.categoryname = params["id"];

      var isRoute = localStorage.getItem('lang') != params["language"] && params["language"];
      await this.changeLang(params["language"]);

      if (isRoute) {
        window.location.reload();
      }
    });
    if (!localStorage.getItem('lang')) {
      this._lang = 'ar';
    }
    else {
      this._lang = (localStorage.getItem('lang')) == "en" ? 'en' : 'ar';
    }
  }


  /** Custom methods */
  async changeLang(lang: string) {
    this.loading.setLang(lang);
    this.apiResources.clearResource();
  }
  
  putVisitNo(itemId: string) {
    this.service.putVisitingCount('opendatalist', itemId).subscribe();
  }

  getOpenData() {
    this.service.getList('opendatalist').pipe(takeUntil(this.destroy$)).subscribe(
      (data: OpenDataList[]) => {
        this.reasearchList = data.filter(m=>m.ItemFields?.ItemCategory?.LookupValue == this.categoryname);
        this.researchCategory = [...new Map(this.reasearchList.map(item => [item.ItemFields?.ItemCategory?.LookupValue, item])).values()]
        .filter(m => m.ItemFields?.ItemCategory)
        .sort((a,b) => 
          b.ItemFields?.ItemCategory?.LookupValue.localeCompare(a.ItemFields?.ItemCategory?.LookupValue)
        )
        this.reasearchListResponse = [... this.reasearchList]

        this.researchCategory.forEach(element => {
          this.hasCategory = true;
          if (this.tags.indexOf(element.ItemFields?.ItemCategory?.LookupValue) == -1) {
            this.tags.push(element.ItemFields?.ItemCategory?.LookupValue);
            this.tagsStatus.push(true);
          }
        });
      }
    );
  }

  getSiteMenu() {

    this.service.getList('SiteMenu').pipe(takeUntil(this.destroy$)).subscribe(
      (data: ListResponse[]) => {
        data.forEach(element => {
          if (element.ItemFields.Title.toLowerCase() === 'opendata') {

            this.PageTitle = element.ItemFields.MenuName;
            this.Title.setTitle(this.EtecFullName + " - " + this.PageTitle);
          }

        });
      }
    );
  }

  
  changeTage() {
    this.tagsStatus.forEach((element, index) => {
      this.tagsStatus[index] = this.tagsAll;
    });
    this.filterChange();
  }

  filterChange() {
    this.selectedTags = [];

    this.tagsStatus.forEach((element, index) => {
      if (element === true) {
        this.selectedTags.push(this.tags[index]);
      }
      //this.tagsNumber.push(0);
    });

    this.tagsAll = true;
    this.tagsStatus.forEach((element) => {
      if (!element) {
        this.tagsAll = false;
      }
    });


    this.getTagsResult();
  }

  getTagsResult() {

    if (!this.tagsAll && this.hasCategory) {
      this.reasearchListResponse = this.reasearchList.filter(x => this.selectedTags.indexOf(x.ItemFields?.ItemCategory?.LookupValue!) != -1);

    } else {
      this.reasearchListResponse = [... this.reasearchList];
    }

    if (this.searchText != '') {
      if (!this.tagsAll && this.hasCategory) {
        this.reasearchListResponse = this.reasearchList.filter(x => this.selectedTags.indexOf(x.ItemFields?.ItemCategory?.LookupValue!) != -1);
      }
      this.reasearchListResponse = this.reasearchListResponse.filter(x => x.ItemFields?.ODTitle?.toUpperCase().includes(this.searchText.toUpperCase()));
    }
  }

  getOpenDataCategory() {
    this.service.getList('OpenDataCategories').pipe(takeUntil(this.destroy$)).subscribe(
      (data: OpenDataCategoryList[]) => {
        this.data = data.filter(m => m.ItemFields?.Title == this.categoryname );
      });
  }
  /** Component events  */
  async ngOnInit() {
    this.getOpenData();

    this.reportdownload = await this.apiResources.getByKey("reportdownload");
    this.reportsearch = await this.apiResources.getByKey("reportsearch");
    this.home = await this.apiResources.getByKey("home");
    this.Category = await this.apiResources.getByKey("Category");
    this.all = await this.apiResources.getByKey('all');
    this.more = await this.apiResources.getByKey('more');
    this.downloadCount = await this.apiResources.getByKey('downloadCount');
    this.PublishDate = await this.apiResources.getByKey('PublishDate');

    this.getSiteMenu();
    this.getOpenDataCategory();
  }

}
